module.exports = __webpack_public_path__ + "img/Surveillance.3ed281d8.png";